import React from 'react';
import { useAppConfig } from '../context/AppConfigContext';
import { useUserPreferences } from '../context/UserPreferencesContext';
import Dashboard from './Dashboard';
import Home from './Home';

// Ticket 77: the landing page is either the new stats dashboard or the old tile grid.
//
// Two things decide it, in order: the admin's own choice, then the org's newDashboardEnabled flag for
// anyone who has not made one. That ordering is what lets one person trial the new dashboard without
// moving everybody, while a rollback of the org default still catches everyone who never chose.
//
// Nothing renders until both have loaded. Guessing and then swapping would flash the wrong dashboard
// on every page load, which is worse than a moment of blank.

const DashboardRoute = () => {
  const { config, loading } = useAppConfig();
  const { dashboardVersion, ready } = useUserPreferences();

  if (loading || !ready) {
    return (
      <div className="container mx-auto px-4 py-8">
        <div className="bg-white rounded-lg shadow-md p-8 text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-jims-cyan mx-auto mb-4" />
          <p className="text-gray-600">Loading&hellip;</p>
        </div>
      </div>
    );
  }

  if (dashboardVersion === 'old') return <Home />;
  if (dashboardVersion === 'new') return <Dashboard />;

  // No personal choice, so follow the org. An absent flag means the new dashboard, since that is what
  // this release ships — rolling back is an explicit newDashboardEnabled=false, never an accident.
  return config?.newDashboardEnabled === false ? <Home /> : <Dashboard />;
};

export default DashboardRoute;
